export const getEditRightsSuccess = (name: string): string =>
  `Права пользователя "${name}" обновлены`;
export const getEditRightsError = (name: string): string =>
  `Не удалось обновить права пользователя "${name}"`;
